import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Botão de alternância de tema (claro/escuro).
 * Variants:
 *  - 'sidebar' → estilo claro pra usar em sidebar do tenant
 *  - 'topbar'  → estilo escuro para o painel super admin
 */
export default function ThemeToggle({ variant = 'sidebar' }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';

  if (variant === 'topbar') {
    return (
      <button
        onClick={toggle}
        data-testid="theme-toggle-btn"
        title={isDark ? 'Mudar para tema claro' : 'Mudar para tema escuro'}
        className="inline-flex items-center justify-center w-9 h-9 rounded-xl text-slate-300 hover:text-amber-300 hover:bg-slate-800 transition-colors"
      >
        {isDark ? <Sun size={16} /> : <Moon size={16} />}
      </button>
    );
  }

  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle-btn"
      title={isDark ? 'Tema claro' : 'Tema escuro'}
      className="w-full flex items-center gap-2 px-3 py-2 text-sm text-slate-500 hover:text-slate-800 hover:bg-slate-50 rounded-xl transition-colors"
    >
      {isDark ? <Sun size={16} /> : <Moon size={16} />}
      <span>{isDark ? 'Tema claro' : 'Tema escuro'}</span>
    </button>
  );
}
